import './App.css';
import {Phone} from './PhoneC.jsx';

export const App = () => {
  return (
    <div className="App">
        <Phone />
    </div>
  );
}